import { Request } from '~src/httpClient/serverApi/requests/Request';

import { ITriggerImportParams } from '../types/IBundleImport';
import { IExecution } from '../types/IExecution';

/**
 * The VizPortal `triggerImport` Web Client method: queues the task that commits an uploaded bundle to
 * this site (CM `enqueueImport`). Resolves with a QUEUED execution carrying the background job id that
 * keys status, cancel and the manifest.
 */
export class TriggerImportRequest extends Request<ITriggerImportParams, IExecution> {
  constructor(params: ITriggerImportParams) {
    super('triggerImport', params);
  }
}
